import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { UiKitDrawerBase } from '@/fo/ui/kit/drawer/base';
import {
  Question,
  QuestionCard,
  Review,
  ReviewCard
} from '@/fo/ui/review/catalog/base';
import { ReviewImage } from '@/fo/ui/review/gallery/base';
import { UiReviewLightboxBase } from '@/fo/ui/review/lightbox/base';

export interface UiReviewDetailBaseProps {
  review?: Review;
  onOpenChange: (open: boolean) => void;
  open?: boolean;
  question?: Question;
  isLoading?: boolean;
}

export function UiReviewDetailBase({
  review,
  onOpenChange,
  open,
  question,
  isLoading
}: UiReviewDetailBaseProps) {
  const t = useTranslations();
  const [lightboxImages, setLightboxImages] = useState<ReviewImage[]>([]);
  const [lightboxImageId, setLightboxImageId] = useState<string | null>(null);

  return (
    <>
      <UiKitDrawerBase
        title={t('review.detail.title')}
        open={open && (!!review || !!question)}
        direction="right"
        onOpenChange={onOpenChange}
      >
        {isLoading && (
          <div className="flex-center h-full">
            <div className="loading w-20" />
          </div>
        )}
        {!isLoading && review && (
          <ReviewCard
            review={review}
            onImageClick={(imageId, images) => {
              setLightboxImageId(imageId);
              setLightboxImages(images);
            }}
          />
        )}
        {!isLoading && !review && question && (
          <QuestionCard question={question} />
        )}
      </UiKitDrawerBase>
      <UiReviewLightboxBase
        images={lightboxImages.map((image) => ({
          id: image.id,
          src: image.url,
          alt: image.alt
        }))}
        title={t('review.detail.title')}
        open={!!lightboxImageId}
        onOpenChange={(open) => {
          if (!open) {
            setLightboxImageId(null);
          }
        }}
      />
    </>
  );
}
